import './language-switcher.scss';

import Icon, { CaretDownFilled } from '@ant-design/icons';
import { Dropdown, Button } from 'antd';
import Text from 'antd/lib/typography/Text';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { languageList, ZLLanguage } from '../../helpers/lang';
import { ReactComponent as Checkmark } from '../../images/svg/icons-checkmark.svg';
import { ReactComponent as Translate } from '../../images/svg/icons-translate.svg';
import { IApplicationState } from '../../store';
import { actionCreators as LanguageActions } from '../../store/Internationalisation';
import BrazeEvents from '../../helpers/braze';
import { push } from 'connected-react-router';

const LanguageSwitcher: React.FunctionComponent = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [menuOpen, setMenuOpen] = useState(false);
    const rtl = useSelector((state: IApplicationState) => state.intl.rtl);
    const currentLanguage = useSelector((state: IApplicationState) => state.intl.currentLocale);
    const currentMoment = useSelector((state: IApplicationState) => state.intl.momentLocale);

    const changeLanguageByPath = (moment: string) => {
        // get path from after the language component
        const location = window.location;
        const path = location.pathname.split('/').filter((o) => o !== '');
        const newPath = `/${moment}/${path.slice(1).join('/')}${location.search}`;
        dispatch(push(newPath));
        changeLanguage(moment);
    };

    const changeLanguage = (lng: string) => {
        dispatch(LanguageActions.changeLocale(lng));
        BrazeEvents.SetUserLanguage(lng);
    };

    const setLanguage = (lng: string) => {
        dispatch(LanguageActions.setLocale(lng));
        BrazeEvents.SetUserLanguage(lng);
    };

    useEffect(() => {
        if (!currentLanguage) {
            return;
        }
        setLanguage(currentLanguage);
    }, [currentLanguage]);

    useEffect(() => {
        // get the first part of the pathname
        const params = window.location.pathname.split('/').filter((o) => o !== '');
        let pathLanguage = '';
        if (params.length > 0) {
            pathLanguage = params[0].toLowerCase();
        }

        if (
            !pathLanguage ||
            pathLanguage === 'book-now' ||
            pathLanguage === 'private-event' ||
            pathLanguage === 'gift-voucher' ||
            pathLanguage === 'processing' ||
            pathLanguage === 'checkout' ||
            pathLanguage === 'booking' ||
            pathLanguage === 'complete'
        ) {
            const location = window.location;

            dispatch(push(`/${currentMoment}${location.pathname}${location.search}`));
        } else if (pathLanguage && pathLanguage !== currentLanguage && pathLanguage !== currentMoment) {
            changeLanguage(pathLanguage);
        }
    }, [dispatch, currentMoment]);


    const items = languageList.map((language: ZLLanguage) => ({
        key: language.momentLocale,
        className: `language-switcher language-item ${currentLanguage === language.code ? 'selected' : ''}`,
        label: (
            <div>
                <Text>{language.displayText}</Text>
                <Icon component={Checkmark} className="zl-icon" />
            </div>
        ),
    }));


    return (
        <Dropdown
            menu={{
                items,
                onClick: (param) => {
                    changeLanguageByPath(param.key.toString());
                },
}}
            placement={rtl ? 'bottomLeft' : 'bottomRight'}
            overlayClassName="language-overlay"
            trigger={['click']}
        >
            <Button
                className="language-link"
                type="link"
                onClick={(event) => {
                    event.preventDefault();
                    setMenuOpen(!menuOpen);
                }}
            >
                <Icon component={Translate} className="zl-icon" />
                <Text>
                    {
                        languageList.find((o) => o.code === (currentLanguage === '' ? t('language') : currentLanguage))
                            ?.displayText
                    }
                </Text>
                <CaretDownFilled className={`caret ${menuOpen ? 'active' : ''}`} />
            </Button>
        </Dropdown>
    );
};

export default LanguageSwitcher;
